export default __webpack_public_path__ + "static/media/folder-language.59d6842c.svg";